import React, {createContext, useContext, useEffect} from 'react';
import PropTypes from 'prop-types';

import SwipeableDrawer from "@mui/material/SwipeableDrawer";

import BottomDrawerHead from "./components/BottomDrawerHead";
import {SidebarContext} from "../../../../SidebarContext";

BottomDrawer.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.any,
    onClose: PropTypes.func
};

export const BottomDrawerContext = createContext({
    handleClose: () => {}
});

function BottomDrawer({open = false, title = null, onClose = () => {}, ...props}) {
    const {openBottomDrawer, closeBottomDrawer} = useContext(SidebarContext)

    const handleClose = () => {
        onClose()
        closeBottomDrawer()
    }

    useEffect(() => {
        if (open) {
            openBottomDrawer()
        } else {
            closeBottomDrawer()
        }
    }, [open, openBottomDrawer, closeBottomDrawer]);
    
    return (
        <BottomDrawerContext.Provider value={{ handleClose: handleClose }}>
            <SwipeableDrawer
                anchor={'bottom'}
                open={open}
                onClose={handleClose}
                onOpen={() => {}} // onOpen is not used in this component but required
                disablePortal={true}
                sx={{
                    '.MuiDrawer-paper': {
                        height:  '100vh',
                        maxHeight: 'calc(100% - 16px)',
                        borderTopLeftRadius: 24,
                        borderTopRightRadius: 24,
                        position: 'fixed',
                    }
                }}
            >
                <BottomDrawerHead onClose={handleClose}>
                    {title}
                </BottomDrawerHead>
                <div style={{padding: '16px'}}>
                    {props.children}
                </div>
            </SwipeableDrawer>
        </BottomDrawerContext.Provider>
    );
}

export default BottomDrawer;
